module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Edit-2168f797e9db3d37ff18688b562afbf3.svg";